<template>
  <div class="wrap-login-page d-flex justify-content-center align-items-center">
    <div class="container">
      <div v-if="close">You may close this window</div>
      <Card v-if="!close">
        <div class="row g-0">
          <div class="col-lg-6">
            <div class="p-lg-5 p-4">
              <div>
                <h5>Setup profile</h5>
              </div>

              <div class="mt-4 pt-3">
                <p class="text-muted">
                  Please setup your Nylas access token, this will open up a
                  popup and you will login to nylas via your active directory
                  user. This will allow the system to act on your behalf, send
                  emails, create calendar entries, and receive automated
                  webhooks.
                </p>

                <div class="alert alert-info" v-if="message">{{ message }}</div>
                <div class="alert alert-warning" v-if="nylasStarted">
                  Please authorize Nylas in the popup. When it is complete the
                  popup will close and you can complete your onboarding
                </div>

                <button
                  type="button"
                  class="btn btn-success pr-4"
                  @click="startNylas"
                >
                  Authorize Nylas
                </button>
                <div  v-if="calendars.length > 0">
                  <h3>To properly use the system, please specify your default calendar</h3>
                <v-select
                  v-model="formData.nylas_calendar_id"
                  :options="calendars"
                  label="name"
                  :reduce="calendar => calendar.id"
                ></v-select>
                <button
                  @click="onComplete"
                  type="button"
                  class="btn btn-primary float-right pr-4"
                >
                  Complete
                </button>
                </div>
                  <router-link class="btn btn-danger float-right" to="/account/logout">
                  Log out
                  </router-link>
              </div>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="wrap-logo w-100 h-100">
              <img
                class="img-fluid w-100"
                src="https://c.tenor.com/Z8IxnZrmkWAAAAAC/blue-flame-flame.gif"
              />
              <img
                src="https://djangompg.blob.core.windows.net/media/images/mansfield-energy-logo.png"
                class="main-logo"
                alt=""
              />
            </div>
          </div>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
// import { authenticationService } from '../services/authentication.service'
import moment from 'moment'
import { required } from 'vuelidate/lib/validators'
import * as nylas from '../services/nylas.service'
import URIMixin from '@/mixins/URI'
import { requestOptions } from '@/helpers/request-options'
import { utilService } from '../services/util.service'
import Card from '@/components/Card'

export default {
  name: 'SetupProfile',
  components: {
    Card
  },
  mixins: [URIMixin],
  data () {
    return {
      loading: true,
      loadingAction: false,
      user: null,
      regions: [],
      nylasStarted: false,
      nylasCompleted: false,
      calendars: [],
      message: false,
      close: false,
      formData: {
        userType: null,
        retail: [],
        wholesale: [],
        nylas_calendar_id: ''
      }
    }
  },
  validations: {
    formData: {
      userType: { required }
    }
  },
  computed: {
    nylasRedirect () {
      let url = this.getUri()
      if (!url.endsWith('/')) {
        url += '/'
      }
      console.log('url', url)
      return `${encodeURIComponent(this.getUri())}nylas/complete`
    },
    nylasUrl () {
      const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/nylas/redirect/?redirect_url=${this.nylasRedirect}`
      console.log(url)
      return url
    }
  },
  created () {
    console.log('here')
    const code = this.$route.query.code
    this.user = utilService.userInforValue
    if (code) {
      window.opener.postMessage(JSON.stringify({ code: code }))
      this.close = true
      return
    }
    window.addEventListener('message', async (event) => {
      console.log(event.data)
      let code
      try {
        code = JSON.parse(event.data).code
      } catch (e) {
        // this.$bvToast.toast('Cannot setup this profile. Please try again later.', {
        //   title: `Validation`,
        //   variant: 'danger'
        // })
        console.log(e)
        return
      }

      if (code) {
        const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/nylas/callback/?code=${code}`

        const response = await fetch(url, requestOptions.get()).then(
          (handleResponse) => handleResponse.json()
        )

        this.user.profile = response.profile
        this.nylasStarted = false
        this.message = 'Fetching your nylas data. This will take some time.'
        const client = nylas.getClient(
          this.user.profile.nylas_access_token
        )
        const eventListService = new nylas.EventListService(client)
        this.calendars = await eventListService.calendars()
        if (this.calendars.length > 0) {
          this.formData.nylas_calendar_id = this.calendars[0].id
        }
        // const contactUrl = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/nylas/contacts/`
        // fetch(contactUrl, requestOptions.get())
        //   .then((handleResponse) => handleResponse.json())
        //   .then(async (contactsResponse) => {
        //     this.message = `Imported ${contactsResponse.data.created} contacts`
        //     this.nylasCompleted = true
        //     this.loading = false
        //   })
        //   .catch((e) => {
        //     this.nylasCompleted = true
        //     this.$bvToast.toast(
        //       'Cannot get nylas data. Please try again later',
        //       {
        //         title: `Nylas Error`,
        //         variant: 'danger'
        //       }
        //     )
        //   })
      }
    })
    this.loading = false
  },
  methods: {
    moment,
    startNylas () {
      const url = this.nylasUrl
      this.nylasStarted = true
      window.open(url, 'nylas', 'menubar=1,resizable=1,width=600,height=400')
    },
    async onComplete () {
      this.loading = true
      const meUrl = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/profile/${this.user.profile.id}/`
      // eslint-disable-next-line no-unused-vars

      fetch(
        meUrl,
        requestOptions.patch({
          nylas_default_calendar: this.formData.nylas_calendar_id
        })
      )
        .then((handleResponse) => handleResponse.json())
        .then((response) => {
          if (response) {
            this.user.profile = response
            // authenticationService.activeDirectoryLogin(this.user)
            // this.$router.push('/')
            utilService.getCurrentUser().then((user) => {
              // this.$router.push('/')
              document.location.href = '/'
            })
          }
        })
    }
  }
}
</script>

<style lang="css" scoped>
.wrap-logo {
  box-shadow: 0px 0px 10px #ddd;
  position: relative;
  padding: 0;
  min-height: 495px;
}

.wrap-logo:before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: #000;
}

.wrap-logo img {
  z-index: 99;
  position: relative;
  height: 100%;
  -o-object-fit: contain;
  object-fit: contain;
  position: absolute;
  top: 15px;
}

.wrap-logo img.main-logo {
  position: absolute;
  width: 180px;
  left: calc(50% - 90px);
  top: calc(25% - 45px);
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/SetupProfile.vue